<template>
  <div>
    <!-- モーダル本体 -->
    <div class="modal_inner modal_inner--example">
      <div class="content03 content03--modal">
        <h2>{{ modalTitle }}</h2>
        <p class="desc">{{ modalMessage }}</p>

        <!-- テーブル表示 -->
        <div v-if="showTable" class="table-container">
          <table class="prize-table">
            <thead>
              <tr>
                <th
                  v-for="header in tableHeaders"
                  :key="header"
                  class="table-header"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tableRows" :key="row.grade" class="table-row">
                <td class="table-cell grade-cell">{{ row.grade }}</td>
                <td
                  v-for="(prize, index) in row.prizes"
                  :key="index"
                  class="table-cell prize-cell"
                >
                  {{ formatPrize(prize) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 閉じるボタン（左下） -->
        <button class="btn_modal_close" @click="$emit('close')">
          <img
            src="../assets/images/parts/ico_close.svg"
            width=""
            height=""
            alt="閉じる"
          />閉じる
        </button>

        <!-- 閉じるボタン（右上） -->
        <button class="btn_modal_close_right" @click="$emit('close')">
          <img
            src="../assets/images/parts/ico_close.svg"
            width=""
            height=""
            alt="閉じる"
          />
        </button>
      </div>
    </div>

    <!-- 背景オーバーレイ（クリックで閉じる） -->
    <div class="modal_outer" @click="$emit('close')"></div>
  </div>
</template>

<script>
export default {
  name: "modalExample",
  props: {
    // 親コンポーネントからデータを受け取る場合
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    modalTitle() {
      return this.initialData.title || "モーダルタイトル";
    },
    modalMessage() {
      return this.initialData.message || "ここにモーダルの内容を記述します。";
    },
    showTable() {
      return this.initialData.showTable || false;
    },
    tableHeaders() {
      return this.initialData.tableData
        ? this.initialData.tableData.headers
        : [];
    },
    tableRows() {
      return this.initialData.tableData ? this.initialData.tableData.rows : [];
    },
  },
  methods: {
    submitAction() {
      // モーダルを閉じる
      this.$emit("close");
    },
    formatPrize(prize) {
      if (prize === 0) {
        return "0";
      }
      return prize.toLocaleString();
    },
  },
};
</script>

<style scoped>
/* モーダル独自のスタイルがあれば記述 */
.modal_inner--example h2 {
  font-size: 18px;
  /* カスタムスタイル */
}

.modal_inner--example p.desc {
  margin-bottom: 10px;
  text-align: center;
}

/* テーブルスタイル */
.table-container {
  margin: 0;
  overflow-x: auto;
}

.prize-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  font-size: 14px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-header {
  background-color: #f8f9fa;
  color: #333;
  font-weight: bold;
  padding: 12px 8px;
  text-align: center;
  border: 1px solid #dee2e6;
  font-size: 13px;
}

.table-row:nth-child(even) {
  background-color: #f8f9fa;
}

.table-row:hover {
  background-color: #e9ecef;
  transition: background-color 0.2s;
}

.table-cell {
  padding: 10px 8px;
  border: 1px solid #dee2e6;
  text-align: center;
}

.grade-cell {
  font-weight: bold;
  background-color: #e3f2fd;
  color: #1976d2;
}

.prize-cell {
  font-family: "Courier New", monospace;
  font-weight: 600;
}

/* レスポンシブ対応 */
@media (max-width: 768px) {
  .prize-table {
    font-size: 12px;
  }

  .table-header,
  .table-cell {
    padding: 8px 4px;
  }
}
</style>

<!-- 既存のCSSを読み込み -->
<style lang="css" src="@/assets/css/style_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_form_parts.css" scoped></style>
<style lang="css" src="@/assets/css/style_mypage.css" scoped></style>
